import { Typography } from '@mui/material'
import { ConsultancyDataProps } from '../../../interfaces/Billing';
import { CreditCardsPlan } from '../../../enums/CreditsCard';
import axios from 'axios';
import { LoadingButton } from '@mui/lab';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from '../../../enums/Approutes';
import { useTranslation } from 'react-i18next';
import ConsultancyModal from '../modal/ConsultancyModal';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import BookConsultancyModal from '../modal/BookConsultancyModal';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import { useToast } from '../../../hooks/useToast';
import { getConfig } from '../../../config/env';

const CreditCards: React.FC<ConsultancyDataProps & { planName: CreditCardsPlan }> = ({ id, price, extras, planName, pinnerProId, credits, pinner_pro, project_name }) => {
    const url = getConfig().BASE_URL;
    const { t } = useTranslation();
    const authToken = sessionStorage.getItem('authToken');
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showBookConsultancyModal, setShowBookConsultancyModal] = useState<boolean>(false);
    const navigate = useNavigate();
    const { freeConsultancySuccess, consultancySuccess, consultancyError } = useToast();

    const goToBilling = () => {
        navigate(AppRoutes.BILLING);
    }

    const handleOpenBookConsultancyModal = () => {
        setShowBookConsultancyModal(true);
    }

    const handleBuy = async (message?: string) => {
        try {
            setIsLoading(true);
            if (planName === CreditCardsPlan.FREE) {
                await axios.post(`${url}/billing/buy-free-consulting/`, {
                    pinner_pro_id: pinnerProId,
                    message: message
                }, {
                    headers: {
                        Authorization: `Bearer ${authToken}`
                    }
                });
                freeConsultancySuccess();
            } else {
                const response = await axios.post(`${url}/billing/buy-consulting/`, {
                    consulting_id: id,
                    message: message
                }, {
                    headers: {
                        Authorization: `Bearer ${authToken}`
                    },
                    validateStatus: () => true
                });
                if (response.status === 200) {
                    consultancySuccess();
                } else if (response.status === 402) {
                    setShowModal(true);
                } else if (response.status === 400) {
                    consultancyError();
                }
            }
        } catch (error) {
            setIsLoading(false);
            consultancyError();
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className='w-[17rem] h-[32rem] flex flex-col p-6 rounded-md shadow-xl'>
            <div className='w-full flex flex-col gap-2 mb-6'>
                <Typography variant='h6'>{planName}</Typography>
                <Typography variant='h3'>{price} €</Typography>
            </div>

            <div className='w-full flex flex-col gap-2 flex-1 min-h-0 overflow-y-auto'>
                <Typography variant='body1' className='text-sm font-bold text-[#475467]'>
                    {t('pinner_pro:credit_card_description')}
                </Typography>
                <div className='flex-1'>
                    <ul className='flex flex-col gap-4 px-1 py-2'>
                        <li className='text-sm font-medium flex justify-start items-start gap-2'>
                            {planName === CreditCardsPlan.FREE ? (
                                <CheckCircleOutlineOutlinedIcon className='text-primary' />
                            ) : (
                                <CheckCircleOutlineOutlinedIcon className='text-primary' />
                            )}
                            {planName === CreditCardsPlan.FREE ? '15' : planName === CreditCardsPlan.LIGHT ? '30' : '60'} {t('pinner_pro:point_1')}
                        </li>
                        <li className='text-sm font-medium flex justify-start items-start gap-2'>
                            {planName === CreditCardsPlan.FREE ? (
                                <CancelOutlinedIcon className='text-[#999a9b]' />
                            ) : planName === CreditCardsPlan.LIGHT ? (
                                <CancelOutlinedIcon className='text-[#999a9b]' />
                            ) : (
                                <CheckCircleOutlineOutlinedIcon className='text-primary' />
                            )}
                            {t('pinner_pro:point_3')}
                        </li>
                    </ul>

                    {(planName === CreditCardsPlan.LIGHT || planName === CreditCardsPlan.PLUS) && (
                        extras && (
                            <div className='mt-4'>
                                <Typography variant='body1' className='text-sm font-bold text-[#475467] mb-2'>
                                    {t('pinner_pro:extra')}
                                </Typography>
                                <ul className='flex flex-col gap-4 px-1 py-2'>
                                    <li className='text-sm font-medium flex justify-start items-start gap-2'>
                                        <AutoAwesomeOutlinedIcon className='text-warning' />
                                        {extras}
                                    </li>
                                </ul>
                            </div>
                        )
                    )}
                </div>
            </div>

            <div className='w-full flex justify-center mt-6'>
                <LoadingButton variant='contained' fullWidth className='bg-primary hover:bg-primary-hover w-full md:w-80' onClick={handleOpenBookConsultancyModal} loading={isLoading}>
                    {t('pinner_pro:consultancy_button')}
                </LoadingButton>
            </div>

            <ConsultancyModal open={showModal} onClose={() => setShowModal(false)} onGoToBilling={goToBilling} />
            <BookConsultancyModal
                open={showBookConsultancyModal}
                onClose={() => setShowBookConsultancyModal(false)}
                handleBookConsultancy={handleBuy}
                credits={credits || price.toString()}
                pinner_pro={pinner_pro || ''}
                project_name={project_name || ''}
            />
        </div>
    )
}

export default CreditCards
